import { VYLABS_BASE_URL, CREATE_SAVED_VIEWS, GET_SAVED_VIEWS, UPDATE_SAVED_VIEWS } from '../../helper/url_helper';
import { post, get, patch } from '../../helper/Api_helper';
import { Toast } from '../Toast-Snackbar/ToastSnackbar';

async function createSavedViews(filters = {}, name, isDefault) {
    try {
        const res = await post(VYLABS_BASE_URL, CREATE_SAVED_VIEWS, {
            filters,
            name,
            scope: "applications_by_job",
            isDefault
        });
        if(res?.view?.id) {
            Toast("success", "Created Successfully!");
            return res.view.id;
        }
        else {
            return "";
        }
    }
    catch(error) {
        console.error("error in createSavedViews", error);
        Toast("error", error.response.data || "Failed to create customized call stages");
        return "";
    }
}

async function getSavedViews() {
    try {
        const res = await get(VYLABS_BASE_URL, `${GET_SAVED_VIEWS}?scope=applications_by_job`);
        return res;
    }
    catch(error) {
        console.error("error in getSavedViews", error);
        return;
    }
}

async function patchSavedViews(saved_id, filters = {}, isDefault, name) {
    try {
        const res = await patch(VYLABS_BASE_URL, `${UPDATE_SAVED_VIEWS}/${saved_id}`, {filters} );
        if(res?.view?.id) {
            Toast("success", "Updated Successfully!");
            return res.view.id;
        }
        else {
            return "";
        }
    }
    catch(error) {
        console.error("error in patchSavedViews", error);
        Toast("error", error.response.data || "Failed to update customized call stages");
        return "";
    }
}

export {createSavedViews, getSavedViews, patchSavedViews};